import FindRecipientPersonaType from '../store/schema/FindRecipientPersonaType';

export default function getFindPeopleResultsAsEmailAddressStrings(
    findPeopleResults: FindRecipientPersonaType[]
): string[] {
    let emailAddresses = [];

    if (findPeopleResults) {
        findPeopleResults.forEach((result, index) => {
            emailAddresses[index] = result.EmailAddress.EmailAddress;
        });
    }

    return emailAddresses;
}
